import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";

import { Asset } from "@hermes/api-model-asset";

import { Product } from "@hermes/api-model-product";
import { LEFT, RIGHT } from "@hermes/utils-generic/constants";

@Component({
    selector: "h-images-gallery",
    templateUrl: "./images-gallery.component.html",
    styleUrl: "./images-gallery.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagesGalleryComponent {
    @Input() public currentIndex: number = 0;
    @Output() public indexChange = new EventEmitter<number>();
    @Input() public prefixTab: string = "tab";
    @Input() public backgroundOnHover: boolean = false;
    @Input() public displayVideoPoster: boolean = false;

    /**
     * Size of the square image
     */
    @Input()
    public thumbnailSize: number = 64;

    public assets: Asset[] = [];

    public productInput!: Product;

    constructor(private readonly changeDetector: ChangeDetectorRef) {}

    private get lastIndex() {
        return Math.max(this.assets.length - 1, 0);
    }

    @Input()
    public set product(product: Product) {
        this.productInput = product;
        if (this.productInput.assets) {
            this.assets = this.displayVideoPoster
                ? this.productInput.assets
                : this.productInput.assets.filter(
                      (asset: Asset) => asset.type === "image",
                  );
        }
    }

    public handleThumbnailSelectedWithClick(event: Event, index: number): void {
        event.preventDefault();
        this.selectThumbnail(index);
    }

    public handleThumbnailSelectedWithKey(event: KeyboardEvent): void {
        if (event.key === RIGHT) {
            this.changeSelectionRight();
        } else if (event.key === LEFT) {
            this.changeSelectionLeft();
        }
    }

    public prefixerAriaControls(index: number): string {
        return `tabpanel${index}`;
    }

    public trackByAssetIndex(index: number): string {
        return `asset_${index}`;
    }

    private changeSelectionLeft(): void {
        if (this.currentIndex > 0) {
            this.currentIndex = this.currentIndex - 1;
            this.selectThumbnail(this.currentIndex);
        }
        this.changeDetector.detectChanges();
    }

    private changeSelectionRight(): void {
        if (this.currentIndex < this.lastIndex) {
            this.currentIndex = this.currentIndex + 1;
            this.selectThumbnail(this.currentIndex);
        }
        this.changeDetector.detectChanges();
    }

    private selectThumbnail(index: number): void {
        this.currentIndex = index;
        this.indexChange.emit(this.currentIndex);
        this.focusThumbnail(index);
        this.changeDetector.detectChanges();
    }

    private focusThumbnail(index: number): void {
        const thumbnail = document.getElementById(`${this.prefixTab}${index}`);
        thumbnail?.focus();
        this.changeDetector.detectChanges();
    }
}
